import { createBrowserRouter, createSearchParams } from "react-router";

import DefaultLayout from "@user/layout/default_layout";

import Main from "@user/views/common/main";

const router = createBrowserRouter([
  {
    element: <DefaultLayout />,
    children: [
      { path: "/", element: <Main /> },
    ]
  }
]);

export const navigateByPath = function(path: string, searchParams?: any) {
  const search = createSearchParams(searchParams as any).toString();
  router.navigate({
    pathname: path,
    search: "?" + search,
  });
};

export const reload = function() {
  const search = new URLSearchParams(window.location.search).toString();;
  router.navigate({
    pathname: window.location.pathname,
    search: "?" + search,
  });
};

export const query = function(key: string) {
  const currParams = new URLSearchParams(window.location.search);
  return currParams.get(key) || "";
}

export default router;
